/**
 * This file is mainly to handle the mapping of data from events object to nodes object
 * Events: represents the actual automation events, holding data to from and to different backend endpoints
 * Nodes: represents the actual object that the diagram workflow uses, holding reference to event, and data
 *		  that represents how each node will be drawn , used by the reactflow lib
 */
import _ from "lodash";
import {
	parseBESendEmailToFE,
	parseFESendEmailToBE,
} from "assets/js/scenes/automations/scenes/AutomationEditor/containers/Actions/SendEmail/Mapper";
import {
	parseBEDelayToFE,
	parseFEDelayToBE,
} from "assets/js/scenes/automations/scenes/AutomationEditor/containers/Conditions/Delay/Mapper";
import {
	parseBEABTestToFE,
	parseFEABTestToBE,
} from "assets/js/scenes/automations/scenes/AutomationEditor/containers/Conditions/ABTest/Mapper";
import {
	parseBEUpdateContactToFE,
	parseFEUpdateContactToBE,
} from "assets/js/scenes/automations/scenes/AutomationEditor/containers/Actions/UpdateContact/Mapper";
import {
	parseBEIfElseToFE,
	parseFEIfElseToBE,
} from "assets/js/scenes/automations/scenes/AutomationEditor/containers/Conditions/IfElse/Mapper";
import {
	parseBESegmentSelectionToFE,
	parseFESegmentSelectionToBE,
} from "assets/js/scenes/automations/scenes/AutomationEditor/containers/Contextual/SegmentSelection/Mapper";
import {
	parseFEContactTaggedToBE,
	parseBEContactTaggedToFE,
} from "assets/js/scenes/automations/scenes/AutomationEditor/containers/Triggers/ContactTagged/Mapper";
// import {
// 	parseFEContactUntaggedToBE,
// 	parseBEContactUntaggedToFE,
// } from "assets/js/scenes/automations/scenes/AutomationEditor/containers/Triggers/ContactUntagged/Mapper";
import { addManualAddContactsTrigger } from "assets/js/scenes/automations/scenes/AutomationEditor/containers/Triggers/ManualTrigger/Mapper";
import { addHelperTrigger } from "assets/js/scenes/automations/scenes/AutomationEditor/containers/Triggers/HelperTrigger/Mapper";
import { MAPPED } from "assets/js/scenes/automations/scenes/AutomationEditor/containers/Conditions/IfElse/SubAutomationsDefinitions";
import { EVENT_TYPES, STRIPE_TRIGGERS } from "assets/js/const/Automations";
import {
	convertTimeWithUnitToSeconds,
	convertSecondsToNearestUnit,
	getRepresentableStepFromSubAutomation,
	helperNode,
} from "assets/js/scenes/automations/containers/editor/utils/utils";
import {
	parseBETriggerToFE,
	parseFETriggerToBE,
} from "../../scenes/AutomationEditor/containers/Triggers/SubscribeTrigger/Mapper";
import {
	getEdge,
	getEventType,
	getEndCoachmarkNode,
	convertPlanToFlatArrayOfActions,
} from "assets/js/scenes/automations/containers/editor/utils/utils";
import { getConnectedEdges, isNode, isEdge } from "react-flow-renderer";
import { mapBEStepsToFEEvents as mapBEStepsToFEEventsV2 } from "../../automationsV2.0/Mappers/EditorMapper";
import {
	getValuesFromVar,
	getValudOfVariable,
} from "../../automationsV2.0/Mappers/ifElseUtils";
import store from "assets/js/store";
import {
	parseFESplit50ToBE,
	parseBESplit50ToFE,
} from "assets/js/scenes/automations/scenes/AutomationEditor/containers/Conditions/Split50/Mapper";
import {
	parseBEDeleteContactToFE,
	parseFEDeleteContactToBE,
} from "../../scenes/AutomationEditor/containers/Actions/DeleteContactFromList/Mapper";
import {
	parseBEAddContactToFE,
	parseFEAddContactToBE,
} from "../../scenes/AutomationEditor/containers/Actions/AddContactToList/Mapper";
import {
	parseBELoopingToFE,
	parseFELoopingToBE,
} from "../../scenes/AutomationEditor/containers/Actions/Looping/Mapper";
import {
	parseBEUpdateContactTagsToFE,
	parseFEUpdateContactTagsToBE,
} from "../../scenes/AutomationEditor/containers/Actions/UpdateContactTags/Mapper";
import { parseBEStripeChargeSucceededToFE, parseFEStripeChargeSucceededToBE } from "../../scenes/AutomationEditor/containers/Triggers/StripeChargeSucceeded/Mapper";
import { parseBEStripeSubscriptionCreatedToFE, parseFEStripeSubscriptionCreatedToBE } from "../../scenes/AutomationEditor/containers/Triggers/StripeSubscriptionCreated/Mapper";
import { parseBEStripeSubscriptionDeletedToFE, parseFEStripeSubscriptionDeletedToBE } from "../../scenes/AutomationEditor/containers/Triggers/StripeSubscriptionDeleted/Mapper";
import { parseBEStripePaymentFailedToFE, parseFEStripePaymentFailedToBE } from "../../scenes/AutomationEditor/containers/Triggers/StripePaymentFailed/Mapper";
import { parseBEStripePaymentSucceededToFE, parseFEStripePaymentSucceededToBE } from "../../scenes/AutomationEditor/containers/Triggers/StripePaymentSucceeded/Mapper";
import { parseBEStripeInvoiceUpcomingToFE, parseFEStripeInvoiceUpcomingToBE } from "../../scenes/AutomationEditor/containers/Triggers/StripeInvoiceUpcoming/Mapper";
import { parseBEStripeSubscriptionUpdatedToFE, parseFEStripeSubscriptionUpdatedToBE } from "../../scenes/AutomationEditor/containers/Triggers/StripeSubscriptionUpdated/Mapper";
import { parseBEStripeInvoiceOverdueToFE, parseFEStripeInvoiceOverdueToBE } from "../../scenes/AutomationEditor/containers/Triggers/StripeInvoiceOverdue/Mapper";
import { parseFEOnScheduleToBE, parseBEOnScheduleToFE } from "../../scenes/AutomationEditor/containers/Triggers/OnSchedule/Mapper";
import { parseFEFilterSetToBE, parseBEFilterSetToFE } from "../../scenes/AutomationEditor/containers/Conditions/FilterSet/Mapper";
import { parseBEEmailAPIToFE, parseFEEmailAPIToBE } from "../../scenes/AutomationEditor/containers/Actions/EmailAPI/Mapper";
import { parseBERSSStoreToFE, parseFERSSSToreToBE } from "../../scenes/AutomationEditor/containers/Actions/RSSStore/Mapper";
import { parseBERSSCheckToFE, parseFERSSCheckToBE } from "../../scenes/AutomationEditor/containers/Conditions/RSSCheck/Mapper";
import { limitsFeaturesAccess, LIMIT_FEATURE } from "assets/js/utils/LimitsAndFeatures";
import { parseBESwitchCaseToFE, parseFESwitchCaseToBE } from "../../scenes/AutomationEditor/containers/Conditions/SwitchCase/Mapper";
const mapBEStepToFEEvent = (automation, mainStep, subStep, target) => {
	switch (subStep.action) {
		case "CampaignEmail.Send":
			return parseBESendEmailToFE(automation, mainStep, subStep, target);
		case "Time.Sleep":
			return parseBEDelayToFE(automation, mainStep, subStep, target);
		case "Condition.Switch":
			return parseBEIfElseToFE(automation, mainStep, subStep, target);
		case "Switch.Case":
			return parseBESwitchCaseToFE(automation, mainStep, subStep, target);
		case "Condition.Split50":
			return parseBESplit50ToFE(automation, mainStep, subStep, target);
		case "Filter.Set":
			return parseBEFilterSetToFE(automation, mainStep, subStep, target);
		case "Contact.SetCustomAttribute":
			return parseBEUpdateContactToFE(automation, mainStep, subStep, target);
		case "Event.Loop":
			return parseBELoopingToFE(automation, mainStep, subStep, target);
		case "Contact.Add":
			return parseBEAddContactToFE(automation, mainStep, subStep, target);
		case "Contact.Remove":
			return parseBEDeleteContactToFE(automation, mainStep, subStep, target);
		case "Condition.ABTest":
			return parseBEABTestToFE(automation, mainStep, subStep, target);
		case "Email.Send":
			return parseBEEmailAPIToFE(automation, mainStep, subStep, target);
		case "RSSItem.Store":
			return parseBERSSStoreToFE(automation, mainStep, subStep, target);
		case "RSSItem.Check":
			return parseBERSSCheckToFE(automation, mainStep, subStep, target);
		case "Contact.Tag":
		case "Contact.Untag":
		case "Contact.Tag.Update":
			return parseBEUpdateContactTagsToFE(
				automation,
				mainStep,
				subStep,
				target
			);
	}
};
const mapFEEventToBEStep = (
	event,
	connectedEdges,
	events,
	nextIndex,
	selfIndex
) => {
	const eventType = getEventType(event.data.type, event.data.baseId);

	switch (eventType) {
		case EVENT_TYPES.TRIGGER_SUBSCRIBED:
			return parseFETriggerToBE(event, events);
		case EVENT_TYPES.TRIGGER_CONTACTTAGGED:
			return parseFEContactTaggedToBE(event, events);
		case EVENT_TYPES.TRIGGER_STRIPE_CHARGE_SUCCEEDED:
			return parseFEStripeChargeSucceededToBE(event, events);
		case EVENT_TYPES.TRIGGER_STRIPE_SUBSCRIPTION_CREATED:
			return parseFEStripeSubscriptionCreatedToBE(event, events);
		case EVENT_TYPES.TRIGGER_STRIPE_SUBSCRIPTION_DELETED:
			return parseFEStripeSubscriptionDeletedToBE(event, events);
		case EVENT_TYPES.TRIGGER_STRIPE_SUBSCRIPTION_UPDATED:
			return parseFEStripeSubscriptionUpdatedToBE(event, events);
		case EVENT_TYPES.TRIGGER_ONSCHEDULE:
			return parseFEOnScheduleToBE(event, events);
		case EVENT_TYPES.TRIGGER_STRIPE_PAYMENT_FAILED:
			return parseFEStripePaymentFailedToBE(event, events);
		case EVENT_TYPES.TRIGGER_STRIPE_PAYMENT_SUCCEEDED:
			return parseFEStripePaymentSucceededToBE(event, events);
		case EVENT_TYPES.TRIGGER_STRIPE_INVOICE_UPCOMING:
			return parseFEStripeInvoiceUpcomingToBE(event, events);
		case EVENT_TYPES.TRIGGER_STRIPE_INVOICE_OVERDUE:
			return parseFEStripeInvoiceOverdueToBE(event, events);
		case EVENT_TYPES.ACTION_SENDEMAIL:
			return parseFESendEmailToBE(
				event,
				connectedEdges,
				events,
				nextIndex,
				selfIndex
			);
		case EVENT_TYPES.ACTION_EMAILAPI:
			return parseFEEmailAPIToBE(
				event,
				connectedEdges,
				events,
				nextIndex,
				selfIndex
			);
		case EVENT_TYPES.ACTION_RSSSTORE:
			return parseFERSSSToreToBE(event, connectedEdges, events, nextIndex, selfIndex);
		case EVENT_TYPES.CONDITION_RSSCHECK:
			return parseFERSSCheckToBE(event, connectedEdges, events, nextIndex, selfIndex);
		case EVENT_TYPES.CONDITION_DELAY:
			return parseFEDelayToBE(event, connectedEdges, events);
		case EVENT_TYPES.CONDITION_IFELSE:
			return parseFEIfElseToBE(event, connectedEdges, events);
		case EVENT_TYPES.CONDITION_SWITCHCASE:
			return parseFESwitchCaseToBE(event, connectedEdges, events);
		case EVENT_TYPES.CONDITION_SPLIT50:
			return parseFESplit50ToBE(event, connectedEdges, events);
		case EVENT_TYPES.CONDITION_FILTERSET:
			return parseFEFilterSetToBE(event, connectedEdges, events);
		case EVENT_TYPES.ACTION_UPDATECONTACT:
			return parseFEUpdateContactToBE(event, connectedEdges, events);
		case EVENT_TYPES.ACTION_LOOP:
			return parseFELoopingToBE(event, connectedEdges, events);
		case EVENT_TYPES.ACTION_ADDCONTACT:
			return parseFEAddContactToBE(event, connectedEdges, events);
		case EVENT_TYPES.ACTION_DELETECONTACT:
			return parseFEDeleteContactToBE(event, connectedEdges, events);
		case EVENT_TYPES.CONDITION_ABTEST:
			return parseFEABTestToBE(event, connectedEdges, events);
		case EVENT_TYPES.ACTION_UPDATECONTACTTAGS:
			return parseFEUpdateContactTagsToBE(event, connectedEdges, events);
	}
};

const getSubAutomationForAMainStep = (automation, step) => {
	return automation.sub_automations.filter(
		(sub) => sub.name == step.args.sub_automation
	)[0];
};
const dummyFunctionToAddId = (automationMainSteps) => {
	automationMainSteps.forEach((mainStep, index) => {
		mainStep.id = mainStep.steps.filter(
			(s) => s.action == "SubAutomation.Call"
		)[0].args.sub_automation;
		mainStep.stepNumber = index;
	});
};
/**
 * The function returns the step that matches the condition in the emit step,so it is basiclly returning the next step,
 * @param {*} automationMainSteps
 * @param {*} emitStep
 */
const getMatchedConditionToEmitStep = (automationMainSteps, emitStep) => {
	// the condition could be one of the two, either a var= certainValue, or the emitStepId could be in an array that we compare to true
	return automationMainSteps.filter((s) => {
		if (s.condition.eq?.value == "${\"" + emitStep.args?.params?.step + "\"}") {
			return true;
		}
		let varValue;
		if (s.condition.or) {
			varValue = getValudOfVariable(
				s.condition.or[s.condition.or.length - 1].eq?.var
			).replace("input.data.step in ", "");
		}
		if (s.condition.eq?.var) {
			varValue = getValudOfVariable(s.condition.eq?.var).replace(
				"input.data.step in ",
				""
			);
		}

		//const varValue = getValudOfVariable(s.condition.eq?.var).replace("input.data.step in ", "");
		if (varValue[0] !== "[") return false;
		const varArray = JSON.parse(varValue);
		if (
			varArray.includes(emitStep.args?.params?.step) &&
			(s.condition.eq?.value == true ||
				(s.condition?.or &&
					s.condition?.or[s.condition.or.length - 1].eq?.value == true))
		) {
			return true;
		}
		return false;
	})[0];
};

const regularAutomationBEtoFE = (automation) => {
	let events = [];
	let links = [];
	let nextStepToTrigger = null;
	let automationMainSteps = [];
	let nextStepCondition = null;
	let newlyCreatedAutomation = false;
	// new automation
	if (
		automation.main.steps.length == 0 ||
		automation.main.steps[1]?.args?.switch?.length == 0
	) {
		nextStepToTrigger = helperNode();
		const coachmark = getEndCoachmarkNode(0, 0);
		const link = getEdge("custom", nextStepToTrigger.id, coachmark.id);
		events.push(coachmark);
		events.push(nextStepToTrigger);
		links.push(link);
		automationMainSteps = [];
		newlyCreatedAutomation = true;
	} else {
		automationMainSteps = convertPlanToFlatArrayOfActions(automation);
		dummyFunctionToAddId(automationMainSteps);

		nextStepToTrigger = {
			id: automationMainSteps[0].id,
		};
		nextStepCondition = automationMainSteps[0].condition;
	}
	automation.trigger.forEach((t, index) => {
		const getTypeOfTrigger = () => {
			if (t.name != "") {
				return t.name;
			} else {
				if ("tag" in t.args) {
					t = { ...t, name: "Contact.Tagged.UnSelected" };
					return "Contact.Tagged.UnSelected";
				}
			}
		};
		const typeOfTrigger = getTypeOfTrigger();
		switch (typeOfTrigger) {
			case "Contact.Added":
				{
					const triggerObject = parseBETriggerToFE(
						t,
						nextStepToTrigger,
						nextStepCondition,
						"",
						index
					);
					links = [...links, ...triggerObject.links];
					events = [...events, ...triggerObject.events];
				}
				break;
			case "Stripe.ChargeSucceeded":
				{
					const triggerObject = parseBEStripeChargeSucceededToFE(
						t,
						nextStepToTrigger,
						nextStepCondition,
						"",
						index
					);
					links = [...links, ...triggerObject.links];
					events = [...events, ...triggerObject.events];
				}
				break;
			case "Stripe.CustomerSubscriptionCreated":
				{
					const triggerObject = parseBEStripeSubscriptionCreatedToFE(
						t,
						nextStepToTrigger,
						nextStepCondition,
						"",
						index
					);
					links = [...links, ...triggerObject.links];
					events = [...events, ...triggerObject.events];
				}
				break;
			case "Stripe.CustomerSubscriptionDeleted":
				{
					const triggerObject = parseBEStripeSubscriptionDeletedToFE(
						t,
						nextStepToTrigger,
						nextStepCondition,
						"",
						index
					);
					links = [...links, ...triggerObject.links];
					events = [...events, ...triggerObject.events];
				}
				break;
			case "Stripe.InvoicePaymentFailed":
				{
					const triggerObject = parseBEStripePaymentFailedToFE(
						t,
						nextStepToTrigger,
						nextStepCondition,
						"",
						index
					);
					links = [...links, ...triggerObject.links];
					events = [...events, ...triggerObject.events];
				}
				break;
			case "Stripe.InvoicePaymentSucceeded":
				{
					const triggerObject = parseBEStripePaymentSucceededToFE(
						t,
						nextStepToTrigger,
						nextStepCondition,
						"",
						index
					);
					links = [...links, ...triggerObject.links];
					events = [...events, ...triggerObject.events];
				}
				break;
			case "Stripe.InvoiceUpcoming":
				{
					const triggerObject = parseBEStripeInvoiceUpcomingToFE(
						t,
						nextStepToTrigger,
						nextStepCondition,
						"",
						index
					);
					links = [...links, ...triggerObject.links];
					events = [...events, ...triggerObject.events];
				}
				break;
			case "Stripe.CustomerSubscriptionUpdated":
				{
					const triggerObject = parseBEStripeSubscriptionUpdatedToFE(
						t,
						nextStepToTrigger,
						nextStepCondition,
						"",
						index
					);
					links = [...links, ...triggerObject.links];
					events = [...events, ...triggerObject.events];
				}
				break;
			case "Stripe.InvoiceOverdue":
				{
					const triggerObject = parseBEStripeInvoiceOverdueToFE(
						t,
						nextStepToTrigger,
						nextStepCondition,
						"",
						index
					);
					links = [...links, ...triggerObject.links];
					events = [...events, ...triggerObject.events];
				}
				break;
			case "On.Schedule":
				{
					const triggerObject = parseBEOnScheduleToFE(
						t,
						nextStepToTrigger,
						nextStepCondition,
						"",
						index
					);
					links = [...links, ...triggerObject.links];
					events = [...events, ...triggerObject.events];
				}
				break;
			case "Contact.Tagged":
			case "Contact.Untagged":
			case "Contact.Tagged.UnSelected":
				{
					const triggerObject = parseBEContactTaggedToFE(
						t,
						nextStepToTrigger,
						nextStepCondition,
						"",
						index
					);
					links = [...links, ...triggerObject.links];
					events = [...events, ...triggerObject.events];
				}
				break;
			// case "Contact.Untagged":
			// 	{
			// 		const triggerObject = parseBEContactUntaggedToFE(
			// 			t,
			// 			nextStepToTrigger,
			// 			nextStepCondition,
			// 			"",
			// 			index
			// 		);
			// 		links = [...links, ...triggerObject.links];
			// 		events = [...events, ...triggerObject.events];
			// 	}
			// 	break;

			default:
				break;
		}
	});
	// by default we need to add a manual add contacts trigger
	const manualTriggerObject = addManualAddContactsTrigger(nextStepToTrigger);
	links = [...links, ...manualTriggerObject.links];
	events = [...events, ...manualTriggerObject.events];

	const helperTriggerObject = addHelperTrigger(nextStepToTrigger);
	links = [...links, ...helperTriggerObject.links];
	events = [...events, ...helperTriggerObject.events];

	automationMainSteps.forEach((route) => {
		// get the actionable step
		const step = route.steps.filter((s) => s.action == "SubAutomation.Call")[0];
		const subAutomationSteps = getSubAutomationForAMainStep(
			automation,
			step
		).steps;
		const subAutomationType = getSubAutomationForAMainStep(
			automation,
			step
		).type;

		const emitStep = subAutomationSteps.filter(
			(s) =>
				s.action == "SubAutomation.Call" &&
				s.args.sub_automation == "emit_next_step"
		)[0];
		const actionableStep = getRepresentableStepFromSubAutomation(
			{
				steps: subAutomationSteps,
			},
			subAutomationType
		);
		const matchedConditionToEmitStep = emitStep
			? getMatchedConditionToEmitStep(automationMainSteps, emitStep)
			: null;
		const targetId = matchedConditionToEmitStep
			? matchedConditionToEmitStep.id
			: null;
		const eventObject = mapBEStepToFEEvent(
			automation,
			actionableStep,
			actionableStep,
			targetId
		);
		if (eventObject) {
			events = [...events, ...eventObject.events];
			links = [...links, ...eventObject.links];
		}
	});
	events = events.filter((element) => {
		return element !== undefined;
	});

	links = links.filter((element) => {
		return element !== undefined;
	});
	if (newlyCreatedAutomation) {
		links.forEach((link) => link.data.hideAddBtn = true);
	}
	return [...events, ...links];
};
const latestConversion = (automation) => {
	if (automation.trigger.find(trigger => trigger.name == "On.Schedule")) {
		return recurringAutomationBEtoFE(automation);
	}
	return regularAutomationBEtoFE(automation);

};

const recurringAutomationBEtoFE = (automation) => {
	let events = [];
	let links = [];
	let nextStepToTrigger = null;
	let automationMainSteps = [];
	let nextStepCondition = null;
	let newlyCreatedAutomation = false;
	// new automation
	if (
		automation.main.steps.length == 0 ||
		automation.main.steps[1]?.args?.switch?.length == 0
	) {
		nextStepToTrigger = helperNode();
		const coachmark = getEndCoachmarkNode(0, 0);
		const link = getEdge("custom", nextStepToTrigger.id, coachmark.id);
		events.push(coachmark);
		events.push(nextStepToTrigger);
		links.push(link);
		automationMainSteps = [];
		newlyCreatedAutomation = true;
	} else {
		automationMainSteps = convertPlanToFlatArrayOfActions(automation);
		dummyFunctionToAddId(automationMainSteps);

		nextStepToTrigger = {
			id: automationMainSteps[0].id,
		};
		nextStepCondition = automationMainSteps[0].condition;
	}
	automation.trigger.forEach((t, index) => {
		const getTypeOfTrigger = () => {
			if (t.name != "") {
				return t.name;
			} else {
				if ("tag" in t.args) {
					t = { ...t, name: "Contact.Tagged.UnSelected" };
					return "Contact.Tagged.UnSelected";
				}
			}
		};
		const typeOfTrigger = getTypeOfTrigger();
		switch (typeOfTrigger) {
			case "On.Schedule":
				{
					const triggerObject = parseBEOnScheduleToFE(
						t,
						nextStepToTrigger,
						nextStepCondition,
						"",
						index
					);
					links = [...links, ...triggerObject.links];
					events = [...events, ...triggerObject.events];
				}
				break;
			default:
				break;
		}
	});


	automationMainSteps.forEach((route) => {
		// get the actionable step
		const step = route.steps.filter((s) => s.action == "SubAutomation.Call")[0];
		const subAutomationSteps = getSubAutomationForAMainStep(
			automation,
			step
		).steps;
		const subAutomationType = getSubAutomationForAMainStep(
			automation,
			step
		).type;

		const emitStep = subAutomationSteps.filter(
			(s) =>
				s.action == "SubAutomation.Call" &&
				s.args.sub_automation == "emit_next_step"
		)[0];
		const actionableStep = getRepresentableStepFromSubAutomation(
			{
				steps: subAutomationSteps,
			},
			subAutomationType
		);
		const matchedConditionToEmitStep = emitStep
			? getMatchedConditionToEmitStep(automationMainSteps, emitStep)
			: null;
		const targetId = matchedConditionToEmitStep
			? matchedConditionToEmitStep.id
			: null;
		const eventObject = mapBEStepToFEEvent(
			automation,
			actionableStep,
			actionableStep,
			targetId
		);
		if (eventObject) {
			events = [...events, ...eventObject.events];
			links = [...links, ...eventObject.links];
		}
	});
	events = events.filter((element) => {
		return element !== undefined;
	});

	links = links.filter((element) => {
		return element !== undefined;
	});
	if (newlyCreatedAutomation) {
		links.forEach((link) => link.data.hideAddBtn = true);
	}
	return [...events, ...links];

};
const mapBEStepsToFEEventsManual = (automation) => {
	let events = [];
	let links = [];
	let nextStepToTrigger = null;
	let automationMainSteps = [];
	let nextStepCondition = null;
	// new automation
	if (
		automation.main.steps.length == 0 ||
		automation.main.steps[1]?.args?.switch?.length == 0
	) {
		nextStepToTrigger = helperNode();
		const coachmark = getEndCoachmarkNode(0, 0);
		const link = getEdge("custom", nextStepToTrigger.id, coachmark.id);
		events.push(coachmark);
		events.push(nextStepToTrigger);
		links.push(link);
		automationMainSteps = [];
	} else {
		automationMainSteps = convertPlanToFlatArrayOfActions(automation);
		dummyFunctionToAddId(automationMainSteps);

		nextStepToTrigger = {
			id: automationMainSteps[0].id,
		};
		nextStepCondition = automationMainSteps[0].condition;
	}
	const triggerObject = parseBESegmentSelectionToFE(
		automation.listId,
		nextStepToTrigger,
		nextStepCondition,
		automation.sub_automations.filter((sub) => sub.type == "ABTest")[0]
	);
	links = [...links, ...triggerObject.links];
	events = [...events, ...triggerObject.events];
	if (
		automation.sub_automations &&
		automation.sub_automations.filter(
			(sub) => sub.name == automationMainSteps[0].id
		)[0].type == "ABTest"
	) {
		links.forEach((l) => (l.data.hideAddBtn = true));
	}
	automationMainSteps.forEach((route) => {
		// get the actionable step
		const step = route.steps.filter((s) => s.action == "SubAutomation.Call")[0];
		if (step.name.includes("internal_")) return;
		const subAutomationSteps = getSubAutomationForAMainStep(
			automation,
			step
		).steps;
		const subAutomationType = getSubAutomationForAMainStep(
			automation,
			step
		).type;
		const emitStep = subAutomationSteps.filter(
			(s) =>
				s.action == "SubAutomation.Call" &&
				s.args.sub_automation == "emit_next_step"
		)[0];
		const actionableStep = getRepresentableStepFromSubAutomation(
			{
				steps: subAutomationSteps,
			},
			subAutomationType
		);
		const matchedConditionToEmitStep = emitStep
			? getMatchedConditionToEmitStep(automationMainSteps, emitStep)
			: null;
		const targetId = matchedConditionToEmitStep
			? matchedConditionToEmitStep.id
			: null;
		const eventObject = mapBEStepToFEEvent(
			automation,
			actionableStep,
			actionableStep,
			targetId
		);
		if (eventObject) {
			events = [...events, ...eventObject.events];
			links = [...links, ...eventObject.links];
		}
	});
	events = events.filter((element) => {
		return element !== undefined;
	});
	links = links.filter((element) => {
		return element !== undefined;
	});
	return [...events, ...links];
};
const mapBEStepsToFEEvents = (automation) => {
	// for backward compitability purporse, we need to do a acheck here to make sure if it is new version or not
	const editorVersion = automation.editor_version
		? automation.editor_version == "manual"
			? "manual"
			: "latest"
		: "2.0";
	switch (editorVersion) {
		case "2.0":
			return mapBEStepsToFEEventsV2(automation);
			break;
		case "manual":
			return mapBEStepsToFEEventsManual(automation);
		default:
			return latestConversion(automation);
			break;
	}
};
const adjustFirstEventAfterTrigger = (events) => {
	const firstElementAfterTriggerId = events.filter(
		(e) =>
			isEdge(e) &&
			events.filter((event) => event.data.type == "trigger")[0].id === e.source
	)[0].target;
	const index = events.findIndex(
		(ele) => ele.id === firstElementAfterTriggerId
	);
	const firstElementAfterTrigger = events[index];
	events.splice(index, 1);
	events.splice(0, 0, firstElementAfterTrigger);
};
const mapFEEventsToBEEvents = (events, activeAutomation) => {
	const editorVersion = activeAutomation.editorVersion
		? activeAutomation.editorVersion == "manual"
			? "manual"
			: "latest"
		: "2.0";
	switch (editorVersion) {
		case "manual":
			return mapFEEventsToBEEventsManual(events, activeAutomation);
		default:
			return mapFEEventsToBEEventsStandard(events, activeAutomation);
	}
};
const mapFEEventsToBEEventsManual = (events, activeAutomation) => {
	const automation = {
		name: activeAutomation.name,
		list_id: activeAutomation.listId,
		id: activeAutomation.id,
		editor_version: "manual",
		trigger: [
			{
				name: "Custom.Event",
				args: {
					customevent_id: activeAutomation.customevent_id,
				},
			},
		],
		main: {
			steps: [
				{
					name: "init",
					action: "Condition.Switch",
					args: {
						switch: [
							{
								steps: [
									{
										name: "addOutput",
										action: "Variable.Set",
										args: {
											"input.data.step_trigger": {},
											"input.data.outputs": [],
											"input.data.loops": {},
										},
									},
								],
								condition: {
									eq: {
										value: true,
										var: "${not(\"step_trigger\" in input.data)}",
									},
								},
							},
						],
					},
				},
				{
					name: "router",
					pausable: "true",
					action: "Condition.Switch",
					args: {
						switch: [],
					},
				},
			],
		},
		sub_automations: [],
	};
	const nodes = events.filter((event) => isNode(event));
	const edges = events.filter((event) => isEdge(event));

	//First step: convert each event to main and subautomation, if it's subautomation is not required
	nodes.forEach((event, index) => {
		if (event.data.baseId == "manual") return;
		const connectedEdges = getConnectedEdges(nodes, edges).filter(
			(edge) => edge.source == event.id
		);
		if (event.data.type == "trigger") {
			automation.list_id = event.data.audience;
			automation.trigger.push(mapFEEventToBEStep(event, null, events));
		} else {
			if (event.data.internal) return;
			const mappedObject = mapFEEventToBEStep(
				event,
				connectedEdges,
				events,
				index + 1,
				index
			);
			if (mappedObject?.main) {
				mappedObject.main.forEach((newStep) => {
					automation.main.steps[1].args.switch = [
						...automation.main.steps[1].args.switch,
						newStep,
					];
				});
			}

			if (mappedObject?.sub)
				automation.sub_automations = [
					...automation.sub_automations,
					...mappedObject.sub,
				];
			// this is required to add the reusable subautomations
			if (mappedObject?.reusableSubAutomations) {
				mappedObject?.reusableSubAutomations.forEach((sub) => {
					if (sub)
						if (
							automation.sub_automations.filter(
								(subAutomation) => subAutomation.name == sub
							).length == 0
						) {
							automation.sub_automations.push(MAPPED[sub]());
						}
				});
			}
		}
	});
	return automation;
};
const automaticAdditionToAutomationFlow = (events, activeAutomation) => {

	let isRecurringAtomation = events.find(event => event.data.baseId == "onSchedule");
	let multipleLists = events.filter(event => event.data.type === "trigger" && event.data.baseId !== "manual").length > 1 && limitsFeaturesAccess(LIMIT_FEATURE.USE_EMAIL_API);
	return {
		name: activeAutomation.name,
		list_id: activeAutomation.listId,
		trigger: [
			{
				name: "Custom.Event",
				args: {
					customevent_id: activeAutomation.customevent_id,
				},
			},
		],
		main: {
			steps: [
				{
					name: "init",
					action: "Condition.Switch",
					args: {
						switch: [
							{
								steps: [
									{
										name: "addOutput",
										action: "Variable.Set",
										args: {
											"input.data.step_trigger": {},
											"input.data.outputs": [],
											"input.data.loops": {},
											...(isRecurringAtomation && { "input.data.filter": {} }),
											...(multipleLists && { "input.data.listId": "${input.data.list.id}" })
										},
									},
								],
								condition: {
									eq: {
										value: true,
										var: "${not(\"step_trigger\" in input.data)}",
									},
								},
							},
						],
					},
				},
				{
					name: "router",
					pausable: "true",
					action: "Condition.Switch",
					args: {
						switch: [],
					},
				},
			],
		},
		sub_automations: [],
	};
};
const mapFEEventsToBEEventsStandard = (events, activeAutomation) => {
	const automation = automaticAdditionToAutomationFlow(events, activeAutomation);
	adjustFirstEventAfterTrigger(events);
	const nodes = events.filter((event) => isNode(event));
	const edges = events.filter((event) => isEdge(event));
	const allActiveTriggers = events.filter((event) => event.data.type === "trigger");
	//First step: convert each event to main and subautomation, if it's subautomation is not required
	nodes.forEach((event, index) => {
		if (event.data.baseId == "manual") return;
		const connectedEdges = getConnectedEdges(nodes, edges).filter(
			(edge) => edge.source == event.id
		);
		if (event.data.type == "trigger") {
			automation.list_id = event.data.audience;
			automation.trigger.push(mapFEEventToBEStep(event, null, events));
		} else {
			if (event.data.internal) return;
			const mappedObject = mapFEEventToBEStep(
				event,
				connectedEdges,
				events,
				index + 1,
				index
			);
			if (mappedObject?.main) {
				mappedObject.main.forEach((newStep) => {
					automation.main.steps[1].args.switch = [
						...automation.main.steps[1].args.switch,
						newStep,
					];
				});
			}

			if (mappedObject?.sub)
				automation.sub_automations = [
					...automation.sub_automations,
					...mappedObject.sub,
				];
			// this is required to add the reusable subautomations
			if (mappedObject?.reusableSubAutomations) {
				mappedObject?.reusableSubAutomations.forEach((sub) => {
					if (sub)
						if (
							automation.sub_automations.filter(
								(subAutomation) => subAutomation.name == sub
							).length == 0
						) {
							let emit_next_step = MAPPED["emit_next_step"]();
							const stripeTriggerInCurrentTriggers = allActiveTriggers
								.filter(trigger => STRIPE_TRIGGERS.includes(trigger.data.baseId))
								.map(trigger => trigger.data.baseId);
							//If there is a Contact.Add action, we need to give regular triggers a customer attribute for it to work.
							if (sub === "emit_next_step" && (stripeTriggerInCurrentTriggers.length !== 0 || automation.sub_automations.filter(
								(subAutomation) => subAutomation.steps[0].action == "Contact.Add"
							).length !== 0)) {
								emit_next_step.steps[0].args.payload.customer = "${input.data.customer}";
								automation.main.steps[0].args.switch[0].steps.push(contactAddModificationForCakemailTriggers);
								if (stripeTriggerInCurrentTriggers.some(item => item.startsWith('Stripe.Invoice'))) {
									emit_next_step.steps[0].args.payload.invoice = "${input.data.invoice}";
									automation.main.steps[0].args.switch[0].steps.push(addInvoiceToInput);
								}
								if (stripeTriggerInCurrentTriggers.includes("Stripe.ChargeSucceeded")) {
									automation.main.steps[0].args.switch[0].steps.push(addChargeToInput);
									emit_next_step.steps[0].args.payload.charge = "${input.data.charge}";
									automation;
								}
								automation.sub_automations.push(emit_next_step);
							}
							else if (sub === "emit_next_step" && allActiveTriggers.find(trigger => trigger.data.baseId === "onSchedule")) {
								emit_next_step.steps[0].args.payload.filter = "${input.data.filter}";
								emit_next_step.steps[0].args.payload.contact = {};
								automation.sub_automations.push(emit_next_step);
							}
							else if (sub === "emit_next_step" && allActiveTriggers.filter(trigger => trigger.data.type === "trigger" && trigger.data.baseId !== "manual").length > 1 && limitsFeaturesAccess(LIMIT_FEATURE.USE_EMAIL_API)) {
								emit_next_step.steps[0].args.payload.listId = "${input.data.listId}";
								automation.sub_automations.push(emit_next_step);
							}
							else {
								automation.sub_automations.push(MAPPED[sub]());
							}
						}
				});
			}
		}
	});
	// having this layer above the automation structure to handle the next and the jump/ emit steps
	adjustNextAndJumpsStepNumbers(automation);
	// having this layer above the automation structure to change it to sequence of switch cases
	splitSwitchToSeveralSwitchCases(automation);
	return automation;
};
const splitSwitchToSeveralSwitchCases = (automation) => {
	const indexOFFirstRouterStep = 1;
	if (automation.main.steps[indexOFFirstRouterStep].args.switch.length <= 10) {
		return;
	} else {
		let currentRouterStepIndex = indexOFFirstRouterStep;
		let currentStepSteps = [];
		automation.main.steps[indexOFFirstRouterStep].args.switch.forEach(
			(step) => {
				if (
					automation.main.steps[currentRouterStepIndex].args.switch.length == 10
				) {
					automation.main.steps.splice(currentRouterStepIndex + 1, 0, {
						name: `router_${currentRouterStepIndex + 1}`,
						pausable: "true",
						action: "Condition.Switch",
						args: {
							switch: [],
						},
					});
					currentRouterStepIndex = currentRouterStepIndex + 1;
					currentStepSteps = [];
				}
				currentStepSteps.push(step);
				automation.main.steps[currentRouterStepIndex].args.switch = [
					...currentStepSteps,
				];
			}
		);
	}
};

const adjustNextAndJumpsStepNumbers = (automation) => {
	const routerSteps = automation.main.steps[1].args.switch;
	const stepPreviousMap = {};
	routerSteps.forEach((step, index) => {
		const currentStepName = step.steps[0].name;
		const subAutomationSteps = automation.sub_automations.filter(
			(sub) => sub.name == step.steps[0].args.sub_automation
		)[0].steps;
		subAutomationSteps.forEach((subStep) => {
			const actionType =
				subStep.action == "Condition.Switch"
					? "switch"
					: subStep.description == "delay"
						? "delay"
						: "default";
			switch (actionType) {
				case "switch":
					{
						// Check if this is a switchCase (has type field) or regular if/else
						const isSwitchCase = subStep.type === "switchCase" || 
							automation.sub_automations.find(sub => sub.name === currentStepName)?.type === "switchCase";
						
						if (isSwitchCase) {
							// Handle multiple switch cases (Case 1, Case 2, Case 3, etc.)
							subStep.args.switch.forEach((switchCase, caseIndex) => {
								if (switchCase.next) {
									if (switchCase.next == "end") {
										delete switchCase.next;
									} else {
										const caseLabel = `Case ${caseIndex + 1}`;
										const nextCaseCondition = `${currentStepName}_case${caseIndex + 1}`;
										stepPreviousMap[switchCase.next] = nextCaseCondition;
										
										// Create the emit caller step
										if (!switchCase.steps) switchCase.steps = [];
										switchCase.steps.push({
											name: `loopback_case_${caseIndex + 1}`,
											action: "SubAutomation.Call",
											args: {
												sub_automation: "emit_next_step",
												params: {
													step: nextCaseCondition,
													delay: 0,
												},
											},
											next: "end",
										});
										delete switchCase.next;
									}
								}
							});
							
							// Handle default branch (subStep.next)
							if (subStep.next) {
								if (subStep.next == "end") {
									delete subStep.next;
								} else {
									const nextDefaultCondition = `${currentStepName}_default`;
									stepPreviousMap[subStep.next] = nextDefaultCondition;
									subAutomationSteps.push({
										name: "loopback_default",
										action: "SubAutomation.Call",
										args: {
											sub_automation: "emit_next_step",
											params: {
												step: nextDefaultCondition,
												delay: 0,
											},
										},
									});
									delete subStep.next;
								}
							}
						} else {
							// Regular if/else handling (backward compatibility)
							// check for the yes branch
							if (subStep.args.switch[0].next) {
								if (subStep.args.switch[0].next == "end") {
									delete subStep.args.switch[0].next;
								} else {
									// nextYesCondition is the yes step name
									const nextYesCondition = `${currentStepName}_yes`;
									stepPreviousMap[
										subStep.args.switch[0].next
									] = `${currentStepName}_yes`;
									// create the emit caller step
									subStep.args.switch[0].steps = [
										{
											name: "loopback",
											action: "SubAutomation.Call",
											args: {
												sub_automation: "emit_next_step",
												params: {
													step: nextYesCondition,
													delay: 0,
												},
											},
											next: "end",
										},
									];
									delete subStep.args.switch[0].next;
								}
							}
							// check for the no branch
							if (subStep.next)
								if (subStep.next == "end") {
									delete subStep.next;
								} else {
									const nextNoCondition = `${currentStepName}_no`;
									stepPreviousMap[subStep.next] = nextNoCondition;
									if (nextNoCondition)
										subAutomationSteps.push({
											name: "loopback_1",
											action: "SubAutomation.Call",
											args: {
												sub_automation: "emit_next_step",
												params: {
													step: nextNoCondition,
													delay: 0,
												},
											},
										});
									delete subStep.next;
								}
						}
					}

					break;
				case "delay":
					{
						if (subStep.next) {
							if (subStep.next == "end") {
								delete subStep.next;
								return;
							} else {
								subAutomationSteps.splice(0, 1, {
									name: subAutomationSteps[0].name,
									action: "SubAutomation.Call",
									args: {
										sub_automation: "emit_next_step",
										params: {
											step: currentStepName,
											//findIndexOfStep(subStep.next,automation),
											delay: subAutomationSteps[0].args.params.delay,
										},
									},
								});

								stepPreviousMap[subStep.next] = currentStepName;
								delete subStep.next;
							}
						}
					}
					break;

				default: {
					if (subStep.next) {
						if (subStep.next == "end") {
							delete subStep.next;
							return;
						} else {
							subAutomationSteps.push({
								name: "loopback",
								action: "SubAutomation.Call",
								args: {
									sub_automation: "emit_next_step",
									params: {
										step: currentStepName,
										delay: 0,
									},
								},
							});
							stepPreviousMap[subStep.next] = currentStepName;
							delete subStep.next;
						}
					}
				}
			}
		});
		// handle the route condition
		if (index !== 0) {
			let stepWithShadows = [stepPreviousMap[step.steps[0].name]];
			if (step.steps[0].inTos && step.steps[0].inTos.length > 0)
				stepWithShadows = [...stepWithShadows, ...step.steps[0].inTos];
			if (
				routerSteps
					.map((r) => r.steps[0])
					.filter((sub) => sub.name == stepWithShadows[0])[0]?.shadows
			) {
				stepWithShadows = [
					...stepWithShadows,
					...routerSteps
						.map((r) => r.steps[0])
						.filter((sub) => sub.name == stepWithShadows[0])[0]?.shadows,
				];
			}
			if (!step.condition)
				step.condition = {
					eq: {
						var:
							"${input.data.step in " + JSON.stringify(stepWithShadows) + "}",
						value: true,
					},
				};
		} else {
			let triggerShadows = [];
			triggerShadows = store.getState().automations.automationEvents
				? store
					.getState()
					.automations.automationEvents.filter(
						(e) => e.data.baseId == "subscribed"
					)[0]?.data?.shadows
				: store
					.getState()
					.automationsV1.automationEvents.filter(
						(e) => e.data.baseId == "subscribed"
					)[0]?.data?.shadows;

			triggerShadows = triggerShadows ? [...triggerShadows] : [];
			if (step.steps[0].inTos && step.steps[0].inTos.length > 0)
				triggerShadows = [...triggerShadows, ...step.steps[0].inTos];
			if (!step.condition)
				step.condition =
					triggerShadows && triggerShadows.length > 0
						? {
							or: [
								{
									eq: {
										var: "${not(\"step\" in input.data)}",
										value: true,
									},
								},
								{
									eq: {
										var:
											"${input.data.step in " +
											JSON.stringify(triggerShadows) +
											"}",
										value: true,
									},
								},
							],
						}
						: {
							eq: {
								var: "${not(\"step\" in input.data)}",
								value: true,
							},
						};
		}
	});
	automation.main.steps[1].args.switch.forEach((step) => {
		if (step.steps) delete step.steps[0].shadows;
		delete step.steps[0].inTos;
	});
	/*if (automation.main.steps[1].args.switch.length > 0)  {
		automation.main.steps[1].args.switch[0].steps.unshift({
			name: "log_visitor",
			action: "Execution.AddVisitor",
			args: {
				contactId: "${input.data.contact.id}",
			},
		});
	}*/
};

const addInvoiceToInput =
{
	name: "addInvoiceToInput",
	action: "Condition.Switch",
	args: {
		switch: [
			{
				steps: [
					{
						name: "doesNotHaveInvoice",
						action: "Variable.Set",
						args: {
							"input.data.invoice": {},
						},
					},
				],
				condition: {
					eq: {
						value: true,
						var: "${not(\"invoice\" in input.data)}",
					},
				},
			},
		],
	},
};

const addChargeToInput =
{
	name: "addChargeInput",
	action: "Condition.Switch",
	args: {
		switch: [
			{
				steps: [
					{
						name: "doesNotHaveCharge",
						action: "Variable.Set",
						args: {
							"input.data.charge": {},
						},
					},
				],
				condition: {
					eq: {
						value: true,
						var: "${not(\"charge\" in input.data)}",
					},
				},
			},
		],
	},
};
const contactAddModificationForCakemailTriggers =
{
	name: "setEmailForAdd",
	action: "Condition.Switch",
	args: {
		switch: [
			{
				steps: [
					{
						name: "addCustomer",
						action: "Variable.Set",
						args: {
							"input.data.customer": {},
						},
					},
					{
						name: "addEmail",
						action: "Variable.Set",
						args: {
							"input.data.customer.email": "${input.data.contact.email}",
						},
					},
				],
				condition: {
					eq: {
						value: true,
						var: "${not(\"customer\" in input.data)}",
					},
				},
			},
			{
				steps: [
					{
						name: "setPreferedLocale",
						action: "Variable.Set",
						args: {
							"input.data.customer.preferred_locales": "${list.concat(input.data.customer.preferred_locales,\"en-us\")}"
						},
					},
				],
				condition: {
					eq: {
						value: true,
						var: "${(\"customer\" in input.data)}",
					},
				},
			}
		],
	},
};

export {
	convertSecondsToNearestUnit,
	convertTimeWithUnitToSeconds,
	mapBEStepsToFEEvents,
	mapFEEventsToBEEvents,
	getMatchedConditionToEmitStep,
};